import React from 'react';

/**
 * Reusable Page Hero Component
 * Used consistently across all internal pages
 * @param {string} title - Page title
 * @param {string} subtitle - Optional subtitle
 */
const PageHero = ({ title, subtitle }) => {
  return (
    <section className="bg-[#1a1a2e] py-16">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-white uppercase mb-2">
          {title}
        </h1>
        <div className="w-20 h-1 bg-[#dc2626] mx-auto"></div>
        {subtitle && (
          <p className="text-gray-300 mt-4 text-lg">{subtitle}</p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
